module.exports = __webpack_public_path__ + "static/media/btn-back-arrow.f3848c79.svg";